/** 初始化websocket地址 */
const initWebSocket = (url: string) => {
  let usersSocketUrl = "";
  if (import.meta.env.VITE_APP_ENV == "development") {
    if (window.location.protocol == "https:") {
      usersSocketUrl = import.meta.env.VITE_APP_BASE_API.replace("https", "wss") + url;
    } else {
      usersSocketUrl = import.meta.env.VITE_APP_BASE_API.replace("http", "ws") + url;
    }
  } else if (import.meta.env.VITE_APP_ENV == "staging") {
    if (window.location.protocol == "https:") {
      usersSocketUrl = "wss://" + window.location.hostname.replaceAll("https", "wss") + url;
    } else {
      usersSocketUrl = "ws://" + window.location.hostname.replaceAll("http", "ws") + url;
    }
  } else {
    if (window.location.protocol == "https:") {
      usersSocketUrl = "wss://" + window.location.host.replaceAll("https", "wss") + url;
    } else {
      usersSocketUrl = "ws://" + window.location.host.replaceAll("http", "ws") + url;
    }
  }
  return usersSocketUrl.replaceAll("api/", "");
};

export default initWebSocket;
